import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { Card } from 'semantic-ui-react';
import Button from './components/Button';
import Content from './components/Content';
import Description from './components/Description';
import Email from './components/Email';
import Instagram from './components/Instagram';
import Location from './components/Location';
import MoreInfoButton from './components/MoreInfoButton';
import Name from './components/Name';
import Phone from './components/Phone';
import Photo from './components/Photo';
import Role from './components/Role';
import Schedule from './components/Schedule';
import Social from './components/Social';
import { classNames } from '../../../../utils/classname';
import { ChildrenPropType } from '../../../foundation/types/component';
import './TeamMember.css';
var defaultProps = {
  className: ''
};
export default function TeamMember(_ref) {
  var children = _ref.children,
    className = _ref.className;
  var finalClassName = classNames(_defineProperty({
    'compound-team-member': true
  }, className, !!className));
  return /*#__PURE__*/React.createElement(Card, {
    className: finalClassName
  }, children);
}
TeamMember.defaultProps = defaultProps;
TeamMember.Photo = Photo;
TeamMember.Name = Name;
TeamMember.Role = Role;
TeamMember.Email = Email;
TeamMember.Phone = Phone;
TeamMember.Description = Description;
TeamMember.Instagram = Instagram;
TeamMember.Location = Location;
TeamMember.Social = Social;
TeamMember.Schedule = Schedule;
TeamMember.Content = Content;
TeamMember.Button = Button;
TeamMember.MoreInfoButton = MoreInfoButton;